/*
 * Graphileon InterActor
 * ---------------------
 * Copyright (c) 2015-2018 Graphileon BV.
 * License: http://www.graphileon.com
 */

(function() {
	require('client/src/css/transitions.scss');

	const ViewRenderer = require('../view-renderer');
	const Empty = require('./vue-components/empty/empty.vue');
	const Vue = require('vue');

	const ComponentLoader = require('client/src/component-loader').default
	const { extend, forEach, get, isObject  } = require('lodash');
	const { urlToHtmlLink } = require('core/src/utils');
	const log = require('core/src/log').instance('client/ui/renderer/vue');
	const IGraphileon = require('core/src/i-graphileon').default;

	// linkify support
	Vue.directive('urlToHtmlLink', (el) => {
		el.innerHTML = urlToHtmlLink(el.innerHTML);
	});


	/* Inheritance and constructor */

	const VueRenderer = function(dependencies) {
		ViewRenderer.call(this, dependencies);
		this.dependencies = dependencies;
		this.graphileon = dependencies.get(IGraphileon)
		this.componentLoader = new ComponentLoader(this.dependencies)
	};
	VueRenderer.prototype = Object.create(ViewRenderer.prototype);
	VueRenderer.prototype.vm = null;
	VueRenderer.prototype.component = null;
	VueRenderer.prototype.$el = null;

	/* Abstracts */

	/**
	 * For override. Should return a Vue Component
	 * @returns {*}
	 */
	VueRenderer.prototype.getVueComponent = function() {
		return Empty;
	};

	/**
	 * For override. Gets the Vue application as argument.
	 */
	VueRenderer.prototype.initVueComponent = function(vueApp) {

	};

	/* Methods */

	VueRenderer.prototype.doRender = function(data) {
		const Component = this.getVueComponent();
		this.$el = $('<div>');
		this.vm = new Vue(Component);
		this.setComponentProps(data);
		this.vm.$graphileon = this.graphileon;
		this.vm.dependencies = this.dependencies
		this.vm.componentLoader = this.componentLoader;
		return this.$el;
	};

	VueRenderer.prototype.doUpdate = function(data, changes) {
		let newData = {};
		forEach(changes, (change, path) => {
			newData[path] = change.new;
		});
		this.setComponentProps(newData);
	};

	VueRenderer.prototype.setComponentProps = function(data) {
		for(let i in data) {
			let path = i.split('.');
			let base = path[0];
			let property = path[path.length-1];
			if(!(base in this.vm.$data)) {
				// Only set predefined data
				continue;
			}

			let obj = this.vm;
			if(path.length > 1) {
				// For paths, get the property's parent object
				obj = get(this.vm, path.slice(0, path.length-1));
				if(!isObject(obj)) {
					log.warn(`Could not set path ${i}.`);
				}
			}

			Vue.set(obj, property, data[i]);
		}
	};

	VueRenderer.prototype.doResize = function() {
		this.vm.onResize();
	};

	VueRenderer.prototype.onReady = function() {
		this.vm.$mount(this.$el[0]);
		this.vm.requestUpdate = this.requestUpdate.bind(this);

		this.vm.$on('trigger', (event) => {
			this.trigger(event);
		});
		this.vm.$on('event', (event) => {
			this.event(event.type, event.data);
		});
		this.vm.$on('context-menu', ({menu, target, x, y}) => {
			this.openContextMenu(menu, target, x, y);
		});
		this.vm.$on('close', (event) => {
			this.close();
		});
		this.initVueComponent(this.vm);
	};

	module.exports = VueRenderer;
})();
